export default __webpack_public_path__ + "static/media/folders.229aac52.png";